import { render, staticRenderFns } from "./ConfirmMessageDlg.vue?vue&type=template&id=3f8f0b06&scoped=true"
import script from "./ConfirmMessageDlg.ts?vue&type=script&lang=ts&external"
export * from "./ConfirmMessageDlg.ts?vue&type=script&lang=ts&external"
import style0 from "./ConfirmMessageDlg.scss?vue&type=style&index=0&id=3f8f0b06&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8f0b06",
  null
  
)

export default component.exports